/**
 * Phone numbers are held without the Armenian trunk "0" (normalizePhone strips "+374"), but
 * copying one yields the dialable form with it (see ClipboardService). Looking a number up with
 * a pasted value therefore has to match both forms, otherwise copy-then-paste finds nothing.
 *
 * Mirrors the rule ClipboardService uses when it adds the "0": an Armenian mobile is 8 digits
 * after the country code. Anything else (e.g. a 9-digit Georgian number) is left as is.
 */

/**
 * Every form a stored phone number can be typed in. The number is judged on its digits alone,
 * so stray spaces or dashes in the stored value, or a "374" country code with no "+", do not
 * stop the local and "0"-prefixed forms being offered.
 */
export function localPhoneForms(mobile: string | null | undefined): string[] {
  if (!mobile) {
    return [];
  }

  const digits = mobile.replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('374') ? digits.slice(3) : digits;

  if (local.length !== 8) {
    return [mobile];
  }

  return [...new Set([mobile, local, `0${local}`])];
}

/** The forms joined into one string, so a plain substring search matches any of them. */
export function withLocalTrunkZero(mobile: string | null | undefined): string {
  return localPhoneForms(mobile).join(' ');
}
